import _ from 'lodash';

export const getValueWithEllipsis = (value, maxLength = 16) => {
    return value.length > maxLength ? `${value.substring(0, maxLength)}...` : value;
}

export const equalsIgnoringCase = (text, other) => {
    return text.localeCompare(other, undefined, { sensitivity: 'base' }) === 0;
}

export const getValueWithoutSpaces = value => {
    return value.replace(/\s/g,'');
};

export const template = (tpl, args) => tpl.replace(/\<(\w+)>/g, (_, v) => args[v]);

export const getNumberMaxDisplay = (count, maxCount) => {
    return {
        count: _.clamp(count, 0, maxCount),
        label: count > maxCount
            ? `${maxCount}+`
            : count
    }
}